"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceType = exports.QuantityUnit = void 0;
/**
 *  A quantity unit for a product.
 */
var QuantityUnit;
(function (QuantityUnit) {
    QuantityUnit["Piece"] = "piece";
    QuantityUnit["Meter"] = "meter";
})(QuantityUnit = exports.QuantityUnit || (exports.QuantityUnit = {}));
var PriceType;
(function (PriceType) {
    PriceType["Monthly"] = "monthly";
    PriceType["Yearly"] = "yearly";
    PriceType["OneTime"] = "one-time";
})(PriceType = exports.PriceType || (exports.PriceType = {}));
//# sourceMappingURL=product.js.map